/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_How_DescriptionInputs */

const en_seo_how_description = /** @type {(inputs: Seo_How_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to move your coaching business to Complete Athlete: an account, your hours, then a booking link for clients. Works for one coach or a whole team.`)
};

const pl_seo_how_description = /** @type {(inputs: Seo_How_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak przenieść biznes trenerski do Complete Athlete: konto, godziny pracy i link do rezerwacji dla podopiecznych. Dla jednego trenera i całego zespołu.`)
};

/**
* | output |
* | --- |
* | "How to move your coaching business to Complete Athlete: an account, your hours, then a booking link for clients. Works for one coach or a whole team." |
*
* @param {Seo_How_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_how_description = /** @type {((inputs?: Seo_How_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_How_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_how_description(inputs)
	return en_seo_how_description(inputs)
});